module.exports = __webpack_public_path__ + "static/media/edit.9924976a.svg";